<template lang="pug">
#transactions.scroll-y.grid-con.full-a
	h3.heading Invoices and Transactions
	section.table-filters
		span.search-filter
			input.g-search(v-model="searchQuery" type="search" placeholder="Search Name")
		span.date-filter
			input(v-model="startDate" type="date")
			| -
			input(v-model="endDate" type="date")
	ul.scroll-y
		li(
			v-for="invoice in filteredResults"
			:key="invoice.invoiceId"
		)
			.transaction-container
				.inv-data.name
					.label Customer Name
					.req-val {{ userStore.users[invoice.userId]?.name.fullName || "Unknown" }}
				.inv-data.name
					.label Dog Name
					.req-val {{ getDogName(invoice.dogId || "Unknown" ) }}
				.inv-data.inv-id
					.label QBO Invoice #
					.req-val {{ invoice.qbInvoiceNumber || "Unknown" }}
				.inv-data.total
					.label Amount
					.req-val $ {{ invoice.paidAmount }} / $ {{ invoice.totalAmount }}
				.inv-data.description
					.label Description
					.req-val {{ invoice.description }}
				.inv-data.due
					.label Due Date
					.req-val {{ invoice.dueAt ? moment(invoice.dueAt).format("ddd, MM/DD/YY, h:mm a") : "-" }}
				.inv-data.options
					button(:class="{open: invOpenSet.has(invoice.$id)}" @click="invOpenSet.has(invoice.$id) ? invOpenSet.delete(invoice.$id) : invOpenSet.add(invoice.$id)")
						include ../resources/icons/chevron-down.pug
				.transaction-options(v-if="invOpenSet.has(invoice.$id)")
					h4.transactions-header Transactions
					.options-container
						template(v-if="invoice.stripePaymentIds?.length")
							table.transaction-table(cellpadding="0" cellspacing="0" border="0")
								thead
									th Amount
									th Initiated
									th Est. Arrival
									th
								InvoiceTransactions(:stripe-ids="invoice.stripePaymentIds || []")
						template(v-else)
							p.no-transactions No transactions captured for this invoice.
</template>

<script setup lang="ts">
import { useInvoices } from '@/store/useInvoices';
import { useUserspace } from '@/store/useUsers';
import { useDogspace } from '@/store/dogspaces';
import moment from "moment";
import InvoiceTransactions from '../components/invoice-transactions.vue';
import { ref, computed, onMounted } from 'vue';
// import { DataInstance } from '@busy-human/gearbox';
// import { Userspaces } from '@busy-human/k9-library';

import { Temporal } from 'temporal-polyfill';

const userStore = useUserspace();
const dogStore = useDogspace();

function getDogName (dogId: any){
	console.log(dogId);
	let dogInfo = "";
	let dog;

	if (dogId in dogStore.dogs) {

		dog = dogStore.dogs[dogId];
		dogInfo = String(dog.name);

	}

	return dogInfo;
	// {{ dogStore.dogs[invoice.dogId]?.name.fullName || "Unknown" }}

}

const invoiceStore = useInvoices();
const invOpenSet = ref(new Set<string>());

onMounted(() => {
	invoiceStore.fetchAllInvoices();
	console.log(invoiceStore);
});

const startDate = ref("");
const endDate = ref("");
const searchQuery = ref("");

function dateparse(str: string) {
	if(!str) return null;
	try {
		return Temporal.PlainDate.from(str);
	} catch (e) {
		console.error(e);
		return null;
	}
}

const filteredResults = computed(() => {
	const query = searchQuery.value.toLowerCase();
	const startVal = dateparse(startDate.value);
	const endVal = dateparse(endDate.value);

	return invoiceStore.asArray.filter(invoice => {
		if(invoice.dueAt && (startVal || endVal)) {
			const invDue = Temporal.PlainDate.from(invoice.dueAt.substring(0, invoice.dueAt.indexOf("T")));
			if(startVal && Temporal.PlainDate.compare(startVal, invDue) > 0) return false;
			if(endVal && Temporal.PlainDate.compare(endVal, invDue) < 0) return false;

		} else if((startVal || endVal) && !invoice.dueAt) {
			console.log("%c *** !invoice.dueAt", "color:aqua;border:aqua;background:black;", startVal,endVal,invoice.dueAt);
			return false;
		}

		if(searchQuery.value) {
			const custName = (userStore.users[invoice.userId]?.name.fullName || "Unknown").toLowerCase();
			if(!custName.includes(query)){
				console.log("%c Customer name is not available ", "color:#ff8800;border:#ff8800;background:black;", query);
				return false;
			}
		}
		console.log("%c Invoice", "color:#88ff00;border:#88ff00;background:black;", invoice);
		return true;
	}).sort((a, b) => b.invoiceId.localeCompare(a.invoiceId));
});
</script>

<style lang="scss">
#transactions {
	padding: 0 1rem;

	.dropdown.full-width {
		width: 100%;
	}

	.transaction-container button {
		background-color: transparent;
	}

	.options-container button {
		margin: .5em;
	}

	.options-container button:hover {
		background-color: $color-black;
	}

	.inv-data.options {
		button {
			transition: transform .15s ease;
			transform: rotate(-90deg);
		}

		button.open {
			transform: rotate(0);
		}
	}

	.selected-account {
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		padding: 2rem;
	}

	.selected-account .details {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
	}

	.selected-account .details .account-info,
	.selected-account .details .invoice-info {
		display: flex;
		width: clamp(400px, 40%, 1000px);
		height: clamp(600px, 100%, 1000px);

		.contact-info {
			display: flex;
			flex-direction: column;
			gap: 0.7rem;
			width: 100%;
			padding: 1rem;
		}

		.contact-info>div {
			box-sizing: border-box;
			width: 100%;
			height: 80px;
			padding: 0.5rem 1rem;
			background-color: $color-white;
			border: 1px solid $color-black;
			box-shadow: 2px 2px 0 $color-black;
		}

		.label {
			color: $color-gray-62;
		}

		.contact-info .data {
			overflow: hidden;
			font-size: 1.2rem;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.contact-info select {
			width: 100%;
			border: unset;
		}
	}

	.account-actions {
		display: flex;
		flex-direction: column;
		gap: 1rem;
	}

	.account-activity-container {
		display: flex;
		flex-direction: column;
		gap: .5rem;
		width: 100%;
		margin-top: 2%;
	}

	.dog-list {
		display: grid;
		grid-auto-flow: column;
		gap: .5rem;
		padding-top: 1rem;
		padding-bottom: 1rem;
		overflow-x: auto;
	}

	.contract-list {
		display: grid;
		grid-auto-columns: 17rem;
		grid-auto-flow: column;
		gap: 1rem;
	}

	.contract-detail {
		display: grid;
		grid-template-columns: min-content auto;
		gap: 0 .5rem;
		padding: 1rem;
		margin-top: 1rem;
		font-size: .9em;
		font-weight: 100;
		cursor: pointer;
		border: 1px solid $color-black;
		border-radius: 1rem;
		box-shadow: 2px 2px 0 $color-black;

		.data-value {
			font-size: 1.1em;
			font-weight: 400;
		}

		.contract-status {
			grid-column: 1 / -1;
			padding: .5rem;
			margin-top: 1rem;
			text-transform: capitalize;
			border: 1px solid $color-gray-62;
			border-radius: .5rem;
		}

		.contract-status .green,
		.contract-status .red {
			font-size: 1.2em;
			color: $color-green;
		}

		.contract-status .red {
			color: $color-red;
		}
	}

	.contract-detail-null {
		width: 100%;
		padding: 2rem;
	}

	.transaction-container {
		// display: flex;
		// justify-content: space-between;
		display: grid;
		grid-template-columns: .5fr .5fr .5fr .5fr 1fr .75fr .1fr;
		grid-auto-flow: dense;
		grid-gap: 1rem;
		margin: 1em 0;
		overflow: hidden;
		border: 1px solid $color-black;
		border-radius: 1rem;
		box-shadow: 2px 2px 0 $color-black;

		.inv-data {
			padding: 1em;
		}

		/* stylelint-disable-next-line no-descending-specificity */
		.label {
			font-weight: 300;
			color: #666;
		}
	}

	.options-container {
		display: flex;
		align-items: center;
		width: 100%;

		.no-transactions {
			padding-left: 1.5em;
		}
	}

	.transaction-options {
		grid-column: 1 / -1;

		.transactions-header {
			padding-left: 1.5em;
		}
	}

	.transaction-table {
		width: 100%;

		table, td {
			border-spacing: 0;
			border-collapse: collapse;
		}

		th {
			padding: .5rem 1em;
			font-weight: 100;
			color: rgba(0 0 0 / 60%);
		}

		td {
			padding: 1rem 1em;
		}

		tr:nth-child(even)  td {
			background: #F4F4F4;
		}
	}

	section.table-filters {
		display: flex;
		gap: 1rem;
		align-items: center;

		input[type="date"] {
			padding: .25rem;
			background: $color-gray-cc;
			border: unset;
		}

		input[type="search"] {
			width: unset;
			color: $color-black;
		}
	}
}
</style>